import 'client-only';

import { type Brand } from '@/consts/brands';
import {
  type AnalyticsPatient,
  type AnalyticsPatientResource,
} from '@/types/metrics/analyticsPatient';
import { get, post } from '@/utils/http/client';
import { urls } from '@/utils/urls';

const getPatient = async (
  brand: Brand,
): Promise<AnalyticsPatientResource | undefined> => {
  const response = await get<{ data: AnalyticsPatientResource }>(
    urls[brand].api.patient.get,
    {
      validateStatus: (status) => status === 200 || status === 401,
    },
  );
  const { data } = response.data;
  return data;
};

const getBasicPatient = async (
  brand: Brand,
): Promise<AnalyticsPatient | undefined> => {
  const response = await get<{ data: AnalyticsPatient }>(
    urls[brand].api.patient.getBasic,
    {
      validateStatus: (status) => status === 200 || status === 401,
    },
  );
  const { data } = response.data;
  return data;
};

const updateLegalName = (
  brand: Brand,
  firstname: string,
  lastname: string,
  dob?: string,
): Promise<void | undefined> => {
  return post(urls[brand].api.patient.updateLegalName, {
    firstname,
    lastname,
    dob,
  });
};

export const UserService = {
  getPatient,
  getBasicPatient,
  updateLegalName,
};
